import { Component, OnInit } from '@angular/core';
import { StorageService } from '../services/storage.service';
import {UserService} from "../services/user.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  currentUser: any;
  newPassword: string = '';
  confirmPassword: string = '';
  oldPassword: string = '';
  loading = false;

  constructor(
    private storageService: StorageService,
    private userService: UserService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.currentUser = this.storageService.getUser();
  }

  changePassword() {
    this.loading = true;
    this.userService.changePassword(this.oldPassword, this.newPassword, this.currentUser.id).subscribe(
      data => {
        this.confirmPassword = '';
        this.newPassword = '';
        this.oldPassword = '';
        this.openSnackBar('Das Passwort wurde erfolgreich geändert.');
        this.loading = false;
      }, error => {
        this.loading = false;
      });
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, '', {
      duration: 4000,
    });
  }
}
